import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressBar } from "@angular/material/progress-bar";
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { DadosNotificacao } from 'app/interfaces/Notificacao';
import { ConfiguracoesService } from 'app/services/agview-connect/configuracoes/configuracoes.service';
import { map, Observable, timer } from 'rxjs';

@Component({
  selector: 'app-notificacao-chat',
  standalone: true,
  imports: [MatProgressBar, CommonModule, TranslocoModule],
  templateUrl: './notificacao-chat.component.html',
  styleUrl: './notificacao-chat.component.css'
})

export class NotificacaoChatComponent {
  @Output() public fecharComponentEmitter: EventEmitter<number> = new EventEmitter();
  @Input({required:true}) public indexNotificacao!: number;
  @Input({required:true}) public dadosNotificacao!: DadosNotificacao;

  public progresso$!: Observable<number>;

  constructor(
    private configuracoesService: ConfiguracoesService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.iniciarTimerNotificacao();
    
  }

  public onClick(): void {
    this.fecharComponente();
    this.router.navigate(['/premoplan/chat']);
  }

  public OnCloseClick(evento:Event): void {
    evento.stopPropagation();
    this.fecharComponente();
  }
  

  public fecharComponente(): void {
    this.fecharComponentEmitter.emit(this.indexNotificacao);
  }


  public iniciarTimerNotificacao(): void {
    const duracao = 5000;
    const intervalo = 100;
    const steps = duracao / intervalo;
    
    this.progresso$ = timer(0, intervalo).pipe(
      map(i => {
        return Math.min(intervalo, (i / steps) * 100)
      })
    );

    timer(duracao + duracao * 0.1).subscribe(() => this.fecharComponente());
  }
}
